import * as React from "react";
const SvgLightningIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "lightning", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "89.71 43.31 53.56 43.31 70.39 0 10.29 56.69 46.44 56.69 29.61 100 89.71 43.31" }));
export default SvgLightningIcon;
